export type Vendor = "AXON" | "LENSLOCK" | "WATCHGUARD";

export type VendorMeta = {
  label: string;
  logo: string;
  accent: string;
  help: string[];
  urlPlaceholder: string;
  agencyLabel: string;
  requiredFields: (
    | "clientId"
    | "clientSecret"
    | "apiUrl"
    | "agencyId"
    | "tenantName"
  )[];
};

export const vendorMeta: Record<Vendor, VendorMeta> = {
  AXON: {
    label: "Axon Evidence.com",
    logo: "https://a.storyblok.com/f/133181/3895x2070/ac2f5fdcce/overview_logo.jpg",
    accent: "#F3B228",
    help: [
      "Client ID/Secret: from Axon Evidence Developer Portal",
      "Evidence URL: youragency.evidence.com",
      "Agency ID: UUID provided by Axon",
    ],
    urlPlaceholder: "youragency.evidence.com",
    agencyLabel: "Agency ID",
    requiredFields: ["clientId", "clientSecret", "apiUrl", "agencyId"],
  },
  LENSLOCK: {
    label: "LensLock",
    logo: "https://cdn.brandfetch.io/idTEyreIqc/w/1080/h/1080/theme/dark/icon.jpeg?c=1dxbfHSJFAPEGdCLU4o5B",
    accent: "#0BA5EC",
    help: [
      "Client ID/Secret: from LensLock admin portal",
      "Evidence URL: youragency.lenslock.io",
      "Organization ID: UUID from LensLock",
      "Tenant Name: label you use for this LensLock tenant",
    ],
    urlPlaceholder: "youragency.lenslock.io",
    agencyLabel: "Organization ID",
    requiredFields: ["clientId", "clientSecret", "apiUrl", "agencyId", "tenantName"],
  },
  WATCHGUARD: {
    label: "WatchGuard",
    logo: "https://cdn.brandfetch.io/idrEbVdCFW/w/1638/h/1638/theme/dark/icon.png?c=1dxbfHSJFAPEGdCLU4o5B",
    accent: "#0EA5E9",
    help: [
      "Client Secret: from your WatchGuard API configuration",
      "API URL: e.g., example.azure-api.us",
    ],
    urlPlaceholder: "example.azure-api.us",
    agencyLabel: "Agency ID",
    requiredFields: ["clientSecret", "apiUrl"],
  },
};

export const steps = ["Select vendor", "Enter credentials"];
